import type { ReactNode } from "react";

const backgroundUrl = new URL("./assets/basel-background.jpg", import.meta.url)
  .href;
const logoUrl = new URL("./assets/logo_neoma.svg", import.meta.url).href;

export function LoginShell({ children }: { children: ReactNode }) {
  return (
    <main className="relative isolate grid min-h-screen min-h-[100svh] place-items-center overflow-hidden text-[#18313b] max-sm:px-[18px] max-sm:pb-[100px] max-sm:pt-[110px]">
      <div
        aria-hidden="true"
        className="absolute inset-0 -z-20 scale-[1.002] bg-cover bg-center"
        style={{ backgroundImage: `url(${backgroundUrl})` }}
      />
      <header
        className="absolute left-[clamp(26px,4vw,64px)] top-[clamp(24px,3.2vw,46px)] z-10 max-sm:left-[22px] max-sm:top-[22px]"
        aria-label="Neoma"
      >
        <img
          className="block h-auto w-[clamp(270px,16vw,365px)] max-sm:w-[270px]"
          src={logoUrl}
          alt="Neoma"
        />
      </header>

      {children}

      <aside
        className="absolute bottom-[clamp(26px,1vw,58px)] right-[clamp(26px,2vw,64px)] flex flex-col items-end text-right text-[rgba(31,54,63,0.77)] [text-shadow:0_1px_2px_rgba(255,255,255,0.32)] max-sm:bottom-[22px] max-sm:right-[22px]"
        aria-label="Location"
      >
        <strong className="text-[17px] font-semibold leading-[1.2]">
          Our Home
        </strong>
        <span className="mt-[3px] text-[13px] leading-[1.3]">
          Basel-Stadt, Switzerland
        </span>
      </aside>
    </main>
  );
}
